import type { AddLocationLocationType } from "@/Shared/Types/locationTypes";
import { isDomesticCanada } from "./isDomesticCanada";

export function isFreightClassRequired(
  pickup: AddLocationLocationType,
  delivery: AddLocationLocationType,
) {
  return !isDomesticCanada(pickup, delivery);
}
